export const SWITCH_BACK_NAV_REFRESH_KEY = 'SwitchBackFromNavRefresh2023';
